import { render, staticRenderFns } from "./CompanyTile.vue?vue&type=template&id=cc565cae&"
import script from "./CompanyTile.vue?vue&type=script&lang=js&"
export * from "./CompanyTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports